import { Chip as JoyChip, styled } from '@mui/joy'
import { myPalette } from '~/shared/lib/theme'

export const Chip = styled(JoyChip)`
  padding: 2px 8px;
  background: ${myPalette.gray['100']};
  border-radius: 16px;
  font-weight: 400;
`
